import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { errorCashRegister } from '@/utils/errors';
import { useState } from 'react';
import { currentFormat } from '@/utils/cases';
import { useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from '@/routes/paths';
import { translates } from '@/utils/translate';
import CashRegisterCloseForm from '../../form/cash-close';

interface SimpleDialogProps {
  open: boolean;
  selectedValue: string;
  onClose: (value: string) => void;
}

type DifferenceProps = {
  difference_cash: number;
  difference_creditCard: number;
  difference_transference: number;
};

const differenceDictionaries = {
  difference_cash: 'Dinero',
  difference_creditCard: 'Tarjeta de credito',
  difference_transference: 'Transferencias',
};

export function CashRegisterClosePage(props: SimpleDialogProps) {
  const { onClose, selectedValue, open } = props;
  const [openDifference, setOpenDifference] = useState(false);
  const { typography } = useTheme();
  const navigate = useNavigate();

  const handleClose = () => {
    onClose(selectedValue);
  };
  const handleClose2 = () => {
    setOpenDifference((prv) => !prv);
  };

  const redirectOrders = () => {
    navigate(PATH_DASHBOARD.orders.list);
  };

  const [differences, setDifferences] = useState<DifferenceProps>({
    difference_cash: 0,
    difference_creditCard: 0,
    difference_transference: 0,
  });
  const { closeCashRegister } = useCashRegisterContext();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (dataForm: Record<string, unknown>) => {
    setIsLoading(true);
    const data = (await closeCashRegister(dataForm)) as any;
    setIsLoading(false);

    if (errorCashRegister[data?.message] === errorCashRegister['difference-cash-close-register']) {
      setDifferences(data.data);
      handleClose2();
    } else {
      handleClose();
    }
  };
  return (
    <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography sx={{ ...typography.h6 }} textAlign="center">
          {openDifference ? 'Diferencias de orden' : 'Cerrar Turno'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {!openDifference ? (
          <CashRegisterCloseForm onSave={handleSubmit} isLoading={isLoading}/>
        ) : (
          Object.keys(differences).map((key: any) => (
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '0.5rem',
                justifyContent: 'center',
              }}
            >
              <Typography sx={{ ...typography.h5 }} textAlign="center">
                {differenceDictionaries[key as keyof DifferenceProps]}:
              </Typography>
              <Stack sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ ...typography.body1 }}>
                  {currentFormat(differences[key as keyof DifferenceProps])}
                </Typography>
                <Typography sx={{ ...typography.subtitle1 }}>
                  {differences[key as keyof DifferenceProps] >= 0 ? ' --- Favor' : ' --- Faltante'}
                </Typography>
              </Stack>
            </Stack>
          ))
        )}
      </DialogContent>
      {openDifference && (
        <DialogActions>
          <Button variant="contained" onClick={redirectOrders}>
            {translates.list + translates.orders}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
